import { gql } from '@apollo/client';

const COUNTRIES_QUERY = gql`
  query countries($limit: Int) {
    countries(limit: $limit) {
      name
      alpha2
      dial
    }
  }
`;

export default COUNTRIES_QUERY;
